document.title = String(document.title || 'VEILENA').replace(/vellora/gi, 'VEILENA').replace(/veilna/gi, 'VEILENA') || 'VEILENA';

const veilenaCheckoutPermalink = (variantId, quantity = 1) => {
  const id = String(variantId || '').replace(/\D/g, '');
  const count = Math.max(1, Number.parseInt(quantity, 10) || 1);
  return id ? `/cart/${id}:${count}?checkout` : '/cart';
};
const veilenaProductCheckout = (form) => {
  const variant = form?.querySelector('input[name="id"]:checked') || form?.querySelector('input[name="id"]');
  let variantId = variant?.dataset.checkoutVariant || variant?.value;
  let quantity = form?.querySelector('input[name="quantity"]')?.value || 1;
  return veilenaCheckoutPermalink(variantId, quantity);
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-country-picker]').forEach((picker) => {
    const form = picker.closest('form');
    const select = form?.querySelector('[data-country-select]');
    const search = picker.querySelector('[data-country-search]');
    const list = picker.querySelector('.country-picker__list');
    const options = [...picker.querySelectorAll('[data-country-option]')];
    const names = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames(['en'], { type: 'region' }) : null;
    const chineseNames = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames(['zh-CN'], { type: 'region' }) : null;
    const currentName = picker.querySelector('[data-country-current-name]');
    if (currentName && names) currentName.textContent = names.of(currentName.dataset.countryIso) || currentName.dataset.countryIso;
    options.forEach((option) => {
      const englishName = names?.of(option.dataset.countryOption) || option.dataset.countryOption;
      const chineseName = chineseNames?.of(option.dataset.countryOption) || '';
      option.dataset.countryName = englishName;
      option.dataset.countrySearch = `${englishName} ${chineseName} ${option.dataset.countryOption}`.toLocaleLowerCase();
      option.setAttribute('aria-label', chineseName && chineseName !== englishName ? `${englishName}，${chineseName}` : englishName);
      const label = option.querySelector('[data-country-label]');
      if (label) label.textContent = englishName;
    });
    let activeMatch = -1;
    const visibleOptions = () => options.filter((option) => !option.hidden);
    const focusMatch = (index) => {
      const visible = visibleOptions();
      if (!visible.length) return;
      activeMatch = Math.max(0, Math.min(index, visible.length - 1));
      const option = visible[activeMatch];
      search?.setAttribute('aria-activedescendant', option.id);
      option.scrollIntoView({ block: 'nearest' });
    };
    const filter = () => {
      const query = (search?.value || '').trim().toLowerCase();
      let firstMatch = null;
      options.forEach((option) => {
        const countrySearch = option.dataset.countrySearch || option.dataset.countryName.toLocaleLowerCase();
        option.hidden = Boolean(query) && !countrySearch.includes(query);
        if (!option.hidden && !firstMatch) firstMatch = option;
      });
      activeMatch = firstMatch ? 0 : -1;
      if (firstMatch && query) requestAnimationFrame(() => {
        if (list) list.scrollTop = Math.max(0, firstMatch.offsetTop - list.offsetTop);
        search?.setAttribute('aria-activedescendant', firstMatch.id);
      });
      if (!query) {
        search?.removeAttribute('aria-activedescendant');
        if (list) list.scrollTop = 0;
      }
    };
    search?.addEventListener('input', filter);
    search?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { picker.open = false; return; }
      if (event.key === 'ArrowDown') { event.preventDefault(); focusMatch(activeMatch + 1); }
      if (event.key === 'ArrowUp') { event.preventDefault(); focusMatch(activeMatch - 1); }
      if (event.key === 'Enter') {
        const visible = visibleOptions();
        const option = visible[Math.max(0, activeMatch)];
        if (option) { event.preventDefault(); option.click(); }
      }
    });
    picker.addEventListener('toggle', () => {
      if (!picker.open) { if (search) search.value = ''; filter(); return; }
      requestAnimationFrame(() => search?.focus());
    });
    document.addEventListener('click', (event) => {
      if (picker.open && !picker.contains(event.target)) picker.open = false;
    });
    options.forEach((option) => option.addEventListener('click', () => {
      if (!select || !form) return;
      select.value = option.dataset.countryOption;
      form.submit();
    }));
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-src]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.src = thumb.dataset.gallerySrc;
        const brand = gallery.querySelector('[data-gallery-brand]');
        if (brand) brand.hidden = !thumb.hasAttribute('data-gallery-primary');
        gallery.querySelectorAll('[data-gallery-src]').forEach((item) => item.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
    const thumbRail = gallery.querySelector('.gallery-thumbs');
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => thumbRail?.scrollBy({ left: -320, behavior: 'smooth' }));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => thumbRail?.scrollBy({ left: 320, behavior: 'smooth' }));
    const dialog = gallery.parentElement?.querySelector('[data-gallery-dialog]') || document.querySelector('[data-gallery-dialog]');
    const dialogImage = dialog?.querySelector('[data-gallery-dialog-image]');
    gallery.querySelector('[data-gallery-open]')?.addEventListener('click', () => {
      if (!dialog || !dialogImage || !main) return;
      dialogImage.src = main.src;
      dialog.showModal();
    });
    dialog?.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog.close());
  });

  document.querySelectorAll('.replica-buy-form').forEach((form) => {
    const quantity = form.querySelector('input[name="quantity"]');
    const priceBox = form.closest('.replica-product-info')?.querySelector('[data-main-price]');
    const productPage = form.closest('.veilena-product-page');
    const gallery = productPage?.querySelector('[data-product-gallery]');
    const galleryMain = gallery?.querySelector('[data-gallery-main]');
    const addButton = form.querySelector('.add-cart');
    const buyNowButton = form.querySelector('.buy-now-button');
    const currentPrice = priceBox?.querySelector('[data-main-current]');
    const comparePrice = priceBox?.querySelector('[data-main-compare]');
    const stickyPrice = document.querySelector('[data-product-sticky-buy] [data-sticky-price]');
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: priceBox?.dataset.currency || window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    let mediaRequest = 0;
    const updateVariantMedia = (choice) => {
      const nextImage = choice?.dataset.skuImage || choice?.dataset.variantImage;
      if (!choice || !galleryMain || !nextImage) return;
      const request = ++mediaRequest;
      const applyImage = () => {
        if (request !== mediaRequest) return;
        galleryMain.classList.add('is-switching');
        window.setTimeout(() => {
          if (request !== mediaRequest) return;
          galleryMain.src = nextImage;
          galleryMain.alt = choice.dataset.variantImageAlt || choice.nextElementSibling?.textContent?.trim() || galleryMain.alt;
          galleryMain.classList.toggle('sku-image-active', Boolean(choice.dataset.skuImage));
          gallery?.querySelectorAll('[data-gallery-src]').forEach((thumb) => {
            thumb.classList.toggle('active', Boolean(choice.dataset.variantMediaId) && thumb.dataset.mediaId === choice.dataset.variantMediaId);
          });
          requestAnimationFrame(() => galleryMain.classList.remove('is-switching'));
        }, 90);
      };
      if (galleryMain.src === new URL(nextImage, window.location.href).href) {
        galleryMain.classList.toggle('sku-image-active', Boolean(choice.dataset.skuImage));
        return;
      }
      const loader = new Image();
      loader.onload = applyImage;
      loader.onerror = applyImage;
      loader.src = nextImage;
    };
    const syncBundleToQuantity = () => {
      const choices = [...form.querySelectorAll('input[data-qty]')];
      if (!choices.length) return;
      const count = Math.max(1, Number(quantity.value || 1));
      choices.forEach((choice) => { choice.checked = Number(choice.dataset.qty) === count; });
    };
    const updateTotal = () => {
      if (!priceBox || !currentPrice) return;
      const count = Math.max(1, Number(quantity.value || 1));
      const selectedVariant = form.querySelector('input[data-variant-option]:checked');
      const selectedSku = selectedVariant || form.querySelector('input[data-sku-option]:checked');
      if (selectedVariant) {
        priceBox.dataset.unitPrice = selectedVariant.dataset.variantPrice || priceBox.dataset.unitPrice;
        priceBox.dataset.unitCompare = selectedVariant.dataset.variantCompare || '0';
        const available = selectedVariant.dataset.variantAvailable === 'true';
        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
        }
        if (buyNowButton) {
          buyNowButton.disabled = !available;
          buyNowButton.textContent = available ? 'BUY NOW' : 'SOLD OUT';
        }
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', selectedVariant.value);
        window.history.replaceState({}, '', nextUrl);
      }
      updateVariantMedia(selectedSku);
      const selectedBundle = form.querySelector('input[data-qty]:checked');
      const discount = Number(selectedBundle?.dataset.discount || 0);
      const discounted = Math.round(Number(priceBox.dataset.unitPrice || 0) * count * (100 - discount) / 100);
      const compareUnit = Number(priceBox.dataset.unitCompare || 0);
      const regular = (compareUnit > Number(priceBox.dataset.unitPrice || 0) ? compareUnit : Number(priceBox.dataset.unitPrice || 0)) * count;
      currentPrice.textContent = money(discounted);
      if (stickyPrice) stickyPrice.textContent = money(discounted);
      if (comparePrice) {
        comparePrice.textContent = money(regular);
        comparePrice.hidden = !(regular > discounted);
      }
    };
    form.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
      syncBundleToQuantity();
      updateTotal();
    });
    form.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
      syncBundleToQuantity();
      updateTotal();
    });
    quantity?.addEventListener('input', () => { syncBundleToQuantity(); updateTotal(); });
    form.querySelectorAll('input[data-qty]').forEach((choice) => {
      choice.addEventListener('change', () => {
        quantity.value = choice.dataset.qty;
        updateTotal();
      });
    });
    form.querySelectorAll('input[data-variant-option], input[data-sku-option]').forEach((choice) => {
      if (choice.dataset.skuImage || choice.dataset.variantImage) {
        const preload = new Image();
        preload.src = choice.dataset.skuImage || choice.dataset.variantImage;
      }
      choice.addEventListener('change', updateTotal);
    });
    updateTotal();
  });

  document.querySelectorAll('[data-product-sticky-buy]').forEach((bar) => {
    const form = document.querySelector('.replica-buy-form');
    const primaryButton = form?.querySelector('.buy-now-button');
    const stickyButton = bar.querySelector('[data-sticky-submit]');
    if (!form || !primaryButton || !stickyButton) return;
    const setVisible = (visible) => {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };
    if ('IntersectionObserver' in window) {
      let primaryVisible = primaryButton.getBoundingClientRect().bottom > 0 && primaryButton.getBoundingClientRect().top < window.innerHeight;
      const renderVisibility = () => setVisible(!primaryVisible && window.scrollY > 120);
      const observer = new IntersectionObserver(([entry]) => { primaryVisible = entry.isIntersecting; renderVisibility(); }, { threshold: .05 });
      observer.observe(primaryButton);
      window.addEventListener('scroll', renderVisibility, { passive: true });
    } else {
      window.addEventListener('scroll', () => setVisible(primaryButton.getBoundingClientRect().bottom < 0 && window.scrollY > 120), { passive: true });
    }
    stickyButton.addEventListener('click', () => {
      window.location.href = veilenaProductCheckout(form);
    });
    new MutationObserver(() => {
      stickyButton.disabled = primaryButton.disabled;
      stickyButton.textContent = primaryButton.textContent;
    }).observe(primaryButton, { attributes: true, childList: true, characterData: true, subtree: true });
  });

  document.querySelectorAll('[data-review-list]').forEach((list) => {
    const more = list.querySelector('[data-review-more]');
    more?.addEventListener('click', () => {
      list.querySelectorAll('[data-review-entry][hidden]').forEach((review) => { review.hidden = false; });
      more.hidden = true;
    });
  });

  document.querySelectorAll('[data-collection-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.href);
    });
  });
  document.querySelectorAll('[data-collection-filter]').forEach((filter) => {
    filter.addEventListener('toggle', () => {
      if (!filter.open) return;
      document.querySelectorAll('[data-collection-filter][open]').forEach((other) => { if (other !== filter) other.open = false; });
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-collection-filter][open]').forEach((filter) => { if (!filter.contains(event.target)) filter.open = false; });
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') document.querySelectorAll('[data-collection-filter][open]').forEach((filter) => { filter.open = false; }); });

  const socialDialog = document.querySelector('[data-social-dialog]');
  const socialPlayer = socialDialog?.querySelector('[data-social-player]');
  document.querySelectorAll('[data-social-video]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!socialDialog || !socialPlayer) return;
      socialPlayer.src = button.dataset.socialVideo;
      socialDialog.showModal();
      socialPlayer.play().catch(() => {});
    });
  });
  socialDialog?.querySelector('[data-social-close]')?.addEventListener('click', () => socialDialog.close());
  socialDialog?.addEventListener('close', () => {
    if (!socialPlayer) return;
    socialPlayer.pause();
    socialPlayer.removeAttribute('src');
    socialPlayer.load();
  });
});

/* Full cart page quantity controls. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cart-line]').forEach((line) => {
    const input = line.querySelector('[data-cart-quantity-input]');
    const form = line.closest('[data-cart-page-form]');
    const update = form?.querySelector('[data-cart-update]');
    if (!input || !update) return;
    const submit = () => update.click();
    line.querySelector('[data-cart-quantity-minus]')?.addEventListener('click', () => {
      input.value = Math.max(0, Number(input.value || 0) - 1);
      submit();
    });
    line.querySelector('[data-cart-quantity-plus]')?.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 0) + 1);
      submit();
    });
    input.addEventListener('change', submit);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.header-cart-count[data-cart-count]').forEach((badge) => {
    const sync = () => { badge.hidden = Number(badge.textContent || 0) < 1; };
    new MutationObserver(sync).observe(badge, { childList: true, characterData: true, subtree: true });
    sync();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const eventDialog = document.querySelector('[data-event-dialog]');
  document.querySelector('[data-event-open]')?.addEventListener('click', () => eventDialog?.showModal());
  document.querySelector('[data-event-close]')?.addEventListener('click', () => eventDialog?.close());

  document.querySelectorAll('[data-environment-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-environment-slide]')];
    const counter = slider.querySelector('[data-environment-current]');
    let active = 0;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const selected = i === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
      });
      if (counter) counter.textContent = String(active + 1).padStart(2, '0');
    };
    slider.querySelector('[data-environment-prev]')?.addEventListener('click', () => show(active - 1));
    slider.querySelector('[data-environment-next]')?.addEventListener('click', () => show(active + 1));
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.social-carousel').forEach((carousel) => {
    const track = carousel.querySelector('[data-social-track]');
    if (!track) return;
    const move = (direction) => track.scrollBy({ left: direction * Math.max(216, track.clientWidth * 0.72), behavior: 'smooth' });
    carousel.querySelector('[data-social-prev]')?.addEventListener('click', () => move(-1));
    carousel.querySelector('[data-social-next]')?.addEventListener('click', () => move(1));

    const videos = [...carousel.querySelectorAll('[data-social-inline]')];
    if (!videos.length || !('IntersectionObserver' in window)) return;
    const visible = new Set();
    let scheduled = 0;
    const loadVideo = (video) => {
      if (video.src || !video.dataset.src) return;
      video.src = video.dataset.src;
      video.load();
    };
    const chooseVideo = () => {
      scheduled = 0;
      const carouselRect = carousel.getBoundingClientRect();
      if (carouselRect.bottom <= 0 || carouselRect.top >= window.innerHeight) {
        videos.forEach((video) => { video.pause(); video.closest('.social-card__media')?.classList.remove('is-autoplaying'); });
        return;
      }
      const center = window.innerWidth / 2;
      const candidates = [...visible].sort((a, b) => Math.abs((a.getBoundingClientRect().left + a.getBoundingClientRect().right) / 2 - center) - Math.abs((b.getBoundingClientRect().left + b.getBoundingClientRect().right) / 2 - center));
      const active = candidates[0];
      videos.forEach((video) => {
        const media = video.closest('.social-card__media');
        if (video !== active) { video.pause(); media?.classList.remove('is-autoplaying'); return; }
        loadVideo(video);
        video.muted = true;
        video.play().then(() => media?.classList.add('is-autoplaying')).catch(() => media?.classList.remove('is-autoplaying'));
      });
    };
    const scheduleChoose = () => { if (!scheduled) scheduled = requestAnimationFrame(chooseVideo); };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
      scheduleChoose();
    }, { threshold: .62 });
    videos.forEach((video) => observer.observe(video));
    track.addEventListener('scroll', scheduleChoose, { passive: true });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.replica-product-grid').forEach((grid) => {
    grid.classList.add('product-rail-ready');
    const reveal = () => requestAnimationFrame(() => grid.classList.add('product-rail-open'));
    if (!('IntersectionObserver' in window)) { reveal(); return; }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      reveal(); observer.disconnect();
    }, { threshold: 0.18 });
    observer.observe(grid);
  });

  document.querySelectorAll('.benefit-cards').forEach((cards) => {
    cards.classList.add('benefits-spread-ready');
    const spread = () => requestAnimationFrame(() => cards.classList.add('benefits-spread-open'));
    if (!('IntersectionObserver' in window)) { spread(); return; }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      spread(); observer.disconnect();
    }, { threshold: 0.22 });
    observer.observe(cards);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const dialog = document.querySelector('[data-footer-dialog]');
  const content = dialog?.querySelector('[data-footer-dialog-content]');
  if (!dialog || !content) return;
  const pages = {
    events: `<section class="events-overlay-page"><header><p class="eyebrow">VEILENA EVENTS</p><h2>Something<br>special, just for<br>you.</h2><p>DISCOVER CURRENT VEILENA EVENTS, LIMITED OFFERS AND LITTLE EXTRAS CREATED<br>FOR OUR COMMUNITY.</p></header><button class="events-overlay-card" type="button" data-footer-focus-newsletter><span class="events-overlay-art"><i></i><b>VEILENA</b><small>WELCOME EVENT</small></span><span class="events-overlay-copy"><span><small>NOW LIVE</small><small>ONGOING</small></span><b>WELCOME EVENT</b><strong>Join the list.<br>Enjoy your<br>welcome offer.</strong><em>VIEW EVENT →</em></span></button></section>`,
    environment: `<section class="environment-overlay-page"><header><div><p class="eyebrow">THE VEILENA EXPERIENCE</p><h2>STORE<br>ENVIRONMENT</h2></div><p>Step inside the VEILENA world—a considered space where<br>beauty, detail and modern design come together.</p></header><div class="environment-overlay-grid"><img src="https://cdn.shopify.com/s/files/1/0983/4686/0824/files/veilena-store-interior-corrected.png" alt="VEILENA store environment 1"><img src="https://veilnabeauty.com/cdn/shop/files/6_6eb4299c-1c58-4b5d-9c5d-f23b421945d8.png?v=1787555690&width=1600" alt="VEILENA store environment 2"><img src="https://cdn.shopify.com/s/files/1/0983/4686/0824/files/veilena-storefront-corrected.png" alt="VEILENA store environment 3"><img src="https://cdn.shopify.com/s/files/1/0983/4686/0824/files/veilena-product-in-store-corrected.png" alt="VEILENA store environment 4"></div></section>`,
    help: `<section class="help-overlay-page"><header><p class="eyebrow">VEILENA SUPPORT</p><h2>How can we help?</h2><p>Find quick answers about your order, delivery, returns and VEILENA<br>products.</p><label class="help-search"><span>⌕</span><input type="search" data-help-search placeholder="Search for an answer..." aria-label="Search help questions"></label><div class="help-filters"><button class="is-active" type="button" data-help-filter="all">ALL QUESTIONS</button><button type="button" data-help-filter="shipping">ORDERS &amp; SHIPPING</button><button type="button" data-help-filter="returns">RETURNS &amp; REFUNDS</button><button type="button" data-help-filter="product">PRODUCT HELP</button><button type="button" data-help-filter="payment">PAYMENT &amp; ACCOUNT</button></div></header><div class="help-answers"><p><span data-help-count>14</span> ANSWERS</p>
    <details data-help-question data-category="shipping"><summary><span><small>ORDERS &amp; SHIPPING</small>How can I track my order?</span><b>＋</b></summary><p>Use the tracking number in your shipping confirmation email or open TRACK PACKAGE from the footer.</p></details>
    <details data-help-question data-category="shipping"><summary><span><small>ORDERS &amp; SHIPPING</small>How long does delivery take?</span><b>＋</b></summary><p>Orders are processed in 1–3 business days. Delivery timing depends on destination and carrier service.</p></details>
    <details data-help-question data-category="shipping"><summary><span><small>ORDERS &amp; SHIPPING</small>Where does VEILENA ship?</span><b>＋</b></summary><p>Available destinations are shown in the country selector at the top or bottom of the store.</p></details>
    <details data-help-question data-category="shipping"><summary><span><small>ORDERS &amp; SHIPPING</small>Can I change or cancel my order?</span><b>＋</b></summary><p>Contact support as soon as possible. Changes cannot be guaranteed after fulfillment begins.</p></details>
    <details data-help-question data-category="returns"><summary><span><small>RETURNS &amp; REFUNDS</small>What is the return policy?</span><b>＋</b></summary><p>Return requests must be made within 2 days of delivery. Items must be unused and in original packaging.</p></details>
    <details data-help-question data-category="returns"><summary><span><small>RETURNS &amp; REFUNDS</small>How do I start a return?</span><b>＋</b></summary><p>Open START A RETURN in the footer and email your order number, item and reason for return.</p></details>
    <details data-help-question data-category="returns"><summary><span><small>RETURNS &amp; REFUNDS</small>When will I receive my refund?</span><b>＋</b></summary><p>Approved refunds are issued after the returned item is received and inspected.</p></details>
    <details data-help-question data-category="product"><summary><span><small>PRODUCT HELP</small>How do I use the VEILENA BLACK BOX?</span><b>＋</b></summary><p>Choose the stamp head, apply a small amount of formula and press gently onto clean, dry skin.</p></details>
    <details data-help-question data-category="product"><summary><span><small>PRODUCT HELP</small>Is the BLACK BOX beginner-friendly?</span><b>＋</b></summary><p>Yes. The precision stamp system is designed to create balanced results quickly and easily.</p></details>
    <details data-help-question data-category="product"><summary><span><small>PRODUCT HELP</small>Is the formula waterproof?</span><b>＋</b></summary><p>The included formula is waterproof and smudge-resistant for reliable everyday wear.</p></details>
    <details data-help-question data-category="product"><summary><span><small>PRODUCT HELP</small>How should I clean the stamp heads?</span><b>＋</b></summary><p>Wipe gently after use with the included cleaning pad and allow each head to dry before storage.</p></details>
    <details data-help-question data-category="payment"><summary><span><small>PAYMENT &amp; ACCOUNT</small>Which payment methods are accepted?</span><b>＋</b></summary><p>Available secure payment methods are displayed at checkout and in the footer.</p></details>
    <details data-help-question data-category="payment"><summary><span><small>PAYMENT &amp; ACCOUNT</small>Is checkout secure?</span><b>＋</b></summary><p>Yes. Checkout uses Shopify's protected payment processing.</p></details>
    <details data-help-question data-category="payment"><summary><span><small>PAYMENT &amp; ACCOUNT</small>Do I need an account to order?</span><b>＋</b></summary><p>No. You can complete checkout as a guest or create an account for easier order access.</p></details></div></section>`,
    track: `<section class="track-overlay-page"><header><p class="eyebrow">VEILENA ORDER SUPPORT</p><h2>Track your<br>package.</h2><p>Choose the tracking method that works best for you. No pre-created<br>account is required.</p></header><div class="track-methods"><article class="track-method track-method--account"><div><span class="track-method-icon">♙</span><em>RECOMMENDED</em></div><small>METHOD ONE</small><h3>Track through<br>your VEILENA<br>account.</h3><p>Sign in to view your order history and the latest delivery information in one place.</p><a href="/account/orders">VIEW MY ORDERS →</a></article><article class="track-method track-method--usps"><div><span class="track-method-icon">▱</span><em>USPS</em></div><small>METHOD TWO</small><h3>Track directly<br>with USPS.</h3><p>Enter the tracking number from your shipping confirmation email.</p><form action="https://tools.usps.com/go/TrackConfirmAction_input" method="get" target="_blank"><label for="UspsTracking">USPS tracking number</label><input id="UspsTracking" name="qtc_tLabels1" required autocomplete="off" placeholder="Enter tracking number"><button type="submit">TRACK WITH USPS →</button></form></article></div></section>`,
    returns: `<section class="support-overlay-page support-overlay-page--returns"><header><p class="eyebrow">RETURNS &amp; SUPPORT</p><h2>Let us make it right.</h2><p>If you have any questions about your order, get in touch. Our team will<br>carefully review your request.</p></header><div class="support-split-card"><article class="support-split-card__action"><span>✉</span><small>SEND US AN EMAIL</small><h3>Tell us what<br>happened.</h3><p>Open your email app and share the details below so our team can help quickly.</p><a href="mailto:veilnabeautyus@gmail.com?subject=VEILENA%20Return%20Request">EMAIL RETURN SUPPORT →</a><b>veilnabeautyus@gmail.com</b></article><article class="support-split-card__details"><small>WHAT TO INCLUDE</small><h3>A few details help<br>us respond faster.</h3><ol><li><span>01</span><div><b>Your order number</b><p>Include the order number shown in your confirmation email.</p></div></li><li><span>02</span><div><b>Your checkout email</b><p>Contact us from the same email address used at checkout whenever possible.</p></div></li><li><span>03</span><div><b>A clear description</b><p>Tell us what happened and attach helpful photos when relevant.</p></div></li></ol></article></div></section>`,
    contact: `<section class="support-overlay-page support-overlay-page--contact"><header><p class="eyebrow">CUSTOMER CARE</p><h2>Contact us.</h2><p>Questions about your order, a product or the VEILENA experience? Our<br>support team is ready to help.</p></header><div class="support-split-card"><article class="support-split-card__action"><span>✉</span><small>EMAIL OUR TEAM</small><h3>How can we<br>help?</h3><p>Open your usual email app, tell us what you need, and leave the rest to us.</p><a href="mailto:veilnabeautyus@gmail.com?subject=VEILENA%20Support">EMAIL OUR SUPPORT TEAM →</a><b>veilnabeautyus@gmail.com</b></article><article class="support-split-card__details"><small>HELP US HELP YOU</small><h3>A little background<br>goes a long way.</h3><ol><li><span>01</span><div><b>Your order number</b><p>If your question relates to an existing order, please include it.</p></div></li><li><span>02</span><div><b>Your checkout email</b><p>Use the same email address you used when placing the order if possible.</p></div></li><li><span>03</span><div><b>A clear description</b><p>Tell us what happened and attach relevant photos if they help explain the issue.</p></div></li></ol></article></div></section>`,
    about: `<section class="about-overlay-page"><header><p class="eyebrow">ABOUT VEILENA</p><h2>Beauty made intuitive.</h2><p>VEILENA creates intuitive beauty tools that make eye looks faster, simpler and easier to master. From clearly defined lower lashes to precise liner details, every product is designed for everyday confidence.</p></header><div class="about-split-card"><article><small>OUR POINT OF VIEW</small><h3>Beauty should feel<br>natural, not<br>complicated.</h3></article><article><p>We believe beauty should feel intuitive, not complicated. Our goal is to combine considered design, useful function and a modern point of view so you can create the look you want with ease.</p><p>VEILENA design begins with tools that fit naturally into real routines—clear in purpose, easy to understand and satisfying to use.</p><ol><li><span>01</span><div><b>INTUITIVE</b><p>Designed to feel familiar from the very first use.</p></div></li><li><span>02</span><div><b>PRACTICAL</b><p>Made to fit naturally into an everyday beauty routine.</p></div></li><li><span>03</span><div><b>EXPRESSIVE</b><p>Tools that help you create beauty your own way.</p></div></li></ol></article></div></section>`,
    careers: `<p class="eyebrow">JOIN VEILENA</p><h2>Careers</h2><p>We are building a modern beauty brand around thoughtful products and memorable customer experiences. Send your introduction and résumé to our team.</p><a class="footer-dialog-button" href="mailto:veilnabeautyus@gmail.com?subject=VEILENA%20Careers">CONTACT OUR TEAM →</a>`,
    icons: `<section class="icons-overlay-page"><p class="eyebrow">VEILENA COMMUNITY</p><h2>VEILENA Icons</h2><p>Real people, individual style and effortless eye looks. VEILENA Icons celebrates the community that brings our products to life.</p><a class="footer-dialog-button" href="https://www.instagram.com/veilna_offical/" target="_blank" rel="noopener">EXPLORE THE COMMUNITY →</a></section>`
  };
  document.querySelectorAll('[data-footer-page]').forEach((link) => link.addEventListener('click', (event) => {
    event.preventDefault();
    dialog.dataset.page = link.dataset.footerPage;
    const template = document.querySelector(`[data-footer-template="${link.dataset.footerPage}"]`);
    content.innerHTML = template?.innerHTML || pages[link.dataset.footerPage] || '';
    dialog.showModal();
    const search = content.querySelector('[data-help-search]');
    const questions = [...content.querySelectorAll('[data-help-question]')];
    const filters = [...content.querySelectorAll('[data-help-filter]')];
    let activeCategory = 'all';
    const updateHelp = () => {
      const query = (search?.value || '').trim().toLowerCase();
      let visible = 0;
      questions.forEach((question) => {
        const matchesCategory = activeCategory === 'all' || question.dataset.category === activeCategory;
        const matchesSearch = !query || question.textContent.toLowerCase().includes(query);
        question.hidden = !(matchesCategory && matchesSearch);
        if (!question.hidden) visible += 1;
      });
      const count = content.querySelector('[data-help-count]'); if (count) count.textContent = visible;
    };
    search?.addEventListener('input', updateHelp);
    filters.forEach((button) => button.addEventListener('click', () => {
      activeCategory = button.dataset.helpFilter; filters.forEach((item) => item.classList.toggle('is-active', item === button)); updateHelp();
    }));
    content.querySelector('[data-footer-focus-newsletter]')?.addEventListener('click', (clickEvent) => {
      clickEvent.preventDefault(); dialog.close(); document.querySelector('#FooterEmail')?.focus(); document.querySelector('#FooterEmail')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }));
  dialog.querySelector('[data-footer-dialog-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-signature-look-link]').forEach((card) => {
    card.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(card.href);
    }, true);
  });

  const drawer = document.querySelector('[data-quick-shop-drawer]');
  const overlay = document.querySelector('[data-quick-shop-overlay]');
  const content = drawer?.querySelector('[data-quick-shop-content]');
  const loading = drawer?.querySelector('[data-quick-shop-loading]');
  const form = drawer?.querySelector('[data-quick-shop-form]');
  const variantSelect = drawer?.querySelector('[data-quick-shop-variant]');
  const quantity = drawer?.querySelector('input[name="quantity"]');
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  const close = () => {
    drawer?.classList.remove('open'); overlay?.classList.remove('open');
    drawer?.setAttribute('aria-hidden', 'true'); document.body.classList.remove('quick-shop-open');
  };
  const open = () => {
    drawer?.classList.add('open'); overlay?.classList.add('open');
    drawer?.setAttribute('aria-hidden', 'false'); document.body.classList.add('quick-shop-open');
  };
  const normalizeBrand = (text) => {
    const value = String(text || '').replace(/vellora/gi, 'VEILENA').replace(/veilna/gi, 'VEILENA');
    return /(?:维莱娜|黑盒|三合一|3\s*合\s*1).*(?:睫毛|眼线|印章)|(?:lash|liner).*(?:stamp|3-in-1)/i.test(value) ? 'VEILENA BLACK BOX — 3-in-1 Precision Eye Stamp Kit' : value;
  };
  const stripHtml = (html) => { const node = document.createElement('div'); node.innerHTML = html || ''; return normalizeBrand((node.textContent || '').trim()); };
  const isVariantAvailable = (product, variant) => Boolean(variant?.available);
  const updatePrice = (product) => {
    const variant = product.variants.find((item) => String(item.id) === variantSelect.value && isVariantAvailable(product, item))
      || product.variants.find((item) => isVariantAvailable(product, item))
      || product.variants.find((item) => String(item.id) === variantSelect.value)
      || product.variants[0];
    if (!variant) return;
    variantSelect.value = String(variant.id);
    const count = Math.max(1, Number(quantity?.value || 1));
    drawer.querySelector('[data-quick-shop-price]').textContent = money(variant.price * count);
    const compare = drawer.querySelector('[data-quick-shop-compare]');
    compare.hidden = !(variant.compare_at_price > variant.price);
    compare.textContent = variant.compare_at_price ? money(variant.compare_at_price * count) : '';
    const available = isVariantAvailable(product, variant);
    const add = form.querySelector('.quick-shop-add'); add.disabled = false; add.textContent = available ? 'Buy now' : 'Check availability';
  };
  document.querySelectorAll('[data-quick-shop]').forEach((trigger) => trigger.addEventListener('click', async (event) => {
    event.preventDefault();
    if (!drawer || !content || !loading || !variantSelect || !form) return;
    loading.hidden = false; loading.textContent = 'Loading…'; content.hidden = true; open();
    try {
      const productUrl = new URL(trigger.href, window.location.origin);
      const productEndpoint = `${productUrl.pathname}.js?country=${encodeURIComponent(window.Shopify?.country || '')}&_=${Date.now()}`;
      const response = await fetch(productEndpoint, { cache: 'no-store', headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' } });
      if (!response.ok) throw new Error('Unable to load product');
      const product = await response.json();
      drawer._veilenaProduct = product;
      const image = drawer.querySelector('[data-quick-shop-image]'); image.src = product.featured_image || product.images?.[0] || ''; image.alt = normalizeBrand(product.title);
      drawer.querySelector('[data-quick-shop-title]').textContent = normalizeBrand(product.title);
      drawer.querySelector('[data-quick-shop-description]').textContent = stripHtml(product.description).slice(0, 650);
      const firstAvailable = product.variants.find((variant) => isVariantAvailable(product, variant)) || product.variants[0];
      variantSelect.innerHTML = product.variants.map((variant) => `<option value="${variant.id}" ${isVariantAvailable(product, variant) ? '' : 'disabled'} ${variant.id === firstAvailable?.id ? 'selected' : ''}>${variant.title}</option>`).join('');
      if (firstAvailable) variantSelect.value = String(firstAvailable.id);
      drawer.querySelector('[data-quick-shop-option-wrap]').hidden = product.variants.length === 1 && product.variants[0].title === 'Default Title';
      quantity.value = 1; variantSelect.onchange = () => updatePrice(product); updatePrice(product);
      loading.hidden = true; content.hidden = false;
    } catch (error) { loading.textContent = 'This product could not be loaded. Please try again.'; }
  }));
  drawer?.querySelector('[data-quick-shop-close]')?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
  drawer?.querySelector('[data-quick-shop-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); if (drawer._veilenaProduct) updatePrice(drawer._veilenaProduct); });
  drawer?.querySelector('[data-quick-shop-plus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) + 1); if (drawer._veilenaProduct) updatePrice(drawer._veilenaProduct); });
  quantity?.addEventListener('input', () => { if (drawer._veilenaProduct) updatePrice(drawer._veilenaProduct); });
  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = veilenaCheckoutPermalink(variantSelect?.value, quantity?.value || 1);
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
});

/* Only BUY NOW goes straight to checkout. ADD TO CART continues to theme.js, which opens the cart drawer. */
document.addEventListener('submit', async (event) => {
  const form = event.target?.closest?.('.replica-buy-form');
  if (!form || !event.submitter?.matches?.('[data-direct-checkout]')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.href = veilenaProductCheckout(form);
}, true);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-offer-countdown]').forEach((countdown, index) => {
    const storageKey = `veilena-offer-end-${index}`;
    const storedEnd = Number(localStorage.getItem(storageKey));
    const duration = ((13 * 24 + 9) * 60 * 60 + 45 * 60 + 34) * 1000;
    const end = storedEnd > Date.now() ? storedEnd : Date.now() + duration;
    localStorage.setItem(storageKey, String(end));
    const fields = {
      days: countdown.querySelector('[data-countdown-days]'),
      hours: countdown.querySelector('[data-countdown-hours]'),
      minutes: countdown.querySelector('[data-countdown-minutes]'),
      seconds: countdown.querySelector('[data-countdown-seconds]')
    };
    const render = () => {
      const remaining = Math.max(0, end - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor(totalSeconds % 86400 / 3600),
        minutes: Math.floor(totalSeconds % 3600 / 60),
        seconds: totalSeconds % 60
      };
      Object.entries(fields).forEach(([key, node]) => { if (node) node.textContent = String(values[key]).padStart(2, '0'); });
    };
    render();
    window.setInterval(render, 1000);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('.review-upsell__media').forEach((media) => {
    let frame = 0;
    const move = (event) => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const bounds = media.getBoundingClientRect();
        const x = ((event.clientX - bounds.left) / bounds.width - .5) * 14;
        const y = ((event.clientY - bounds.top) / bounds.height - .5) * 14;
        media.style.setProperty('--offer-shift-x', `${x.toFixed(2)}px`);
        media.style.setProperty('--offer-shift-y', `${y.toFixed(2)}px`);
      });
    };
    const reset = () => {
      if (frame) cancelAnimationFrame(frame);
      media.style.setProperty('--offer-shift-x', '0px');
      media.style.setProperty('--offer-shift-y', '0px');
    };
    media.addEventListener('pointermove', move, { passive: true });
    media.addEventListener('pointerleave', reset, { passive: true });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-accordions]').forEach((accordion) => {
    const items = [...accordion.querySelectorAll('details')];
    items.forEach((item) => item.addEventListener('toggle', () => {
      if (!item.open) return;
      items.forEach((other) => {
        if (other !== item && other.open) other.open = false;
      });
      window.setTimeout(() => {
        const scroller = item.closest('.replica-product-info');
        if (!scroller) return;
        if (['auto', 'scroll'].includes(getComputedStyle(scroller).overflowY)) {
          const itemTop = item.getBoundingClientRect().top;
          const scrollerTop = scroller.getBoundingClientRect().top;
          scroller.scrollTo({ top: scroller.scrollTop + itemTop - scrollerTop - 12, behavior: 'smooth' });
        } else if (window.matchMedia('(max-width: 1199px)').matches) {
          item.querySelector('summary')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 80);
    }));
  });

  document.querySelectorAll('[data-open-review-form]').forEach((button) => {
    button.addEventListener('click', (event) => {
      const form = document.querySelector('#write-review');
      if (!form) return;
      event.preventDefault();
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(() => form.querySelector('input:not([type="hidden"]), textarea, select')?.focus({ preventScroll: true }), 520);
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-before-after]').forEach((comparison) => {
    const range = comparison.querySelector('[data-before-after-range]');
    const after = comparison.querySelector('[data-before-after-after]');
    const divider = comparison.querySelector('[data-before-after-divider]');
    const images = comparison.querySelectorAll('.before-after-layer img');
    const layout = () => {
      const width = comparison.clientWidth;
      images.forEach((image, index) => {
        image.style.width = `${width * 2}px`;
        image.style.left = index === 0 ? '0px' : `${-width}px`;
      });
      const position = Number(range.value || 50);
      after.style.clipPath = `inset(0 0 0 ${position}%)`;
      divider.style.left = `${position}%`;
    };
    range.addEventListener('input', layout);
    images.forEach((image) => image.addEventListener('load', layout, { once: true }));
    if ('ResizeObserver' in window) new ResizeObserver(layout).observe(comparison);
    window.addEventListener('resize', layout, { passive: true });
    layout();
  });

  document.querySelectorAll('[data-review-list]').forEach((list) => {
    const entries = () => [...list.querySelectorAll('[data-review-entry]')];
    const loadMore = list.querySelector('[data-review-more]');
    const filter = list.querySelector('[data-review-filter]');
    const sort = list.querySelector('[data-review-sort]');
    let fiveOnly = false;
    filter?.addEventListener('click', () => {
      fiveOnly = !fiveOnly;
      filter.setAttribute('aria-pressed', String(fiveOnly));
      entries().forEach((entry) => { entry.hidden = fiveOnly && entry.querySelector('.review-stars')?.textContent.trim() !== '★★★★★'; });
      if (loadMore) loadMore.hidden = fiveOnly;
    });
    sort?.addEventListener('click', () => {
      entries().reverse().forEach((entry) => list.insertBefore(entry, loadMore));
      sort.classList.toggle('is-reversed');
    });
  });

  document.querySelectorAll('[data-ugc-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-ugc-track]');
    const videos = [...carousel.querySelectorAll('video')];
    carousel.querySelectorAll('[data-ugc-play]').forEach((button) => {
      button.addEventListener('click', async () => {
        const wrapper = button.closest('.product-ugc__video');
        const video = wrapper?.querySelector('video');
        if (!video) return;
        videos.forEach((other) => { if (other !== video) { other.pause(); other.closest('.product-ugc__video')?.classList.remove('is-playing'); } });
        video.controls = true;
        try { await video.play(); wrapper.classList.add('is-playing'); } catch (error) { wrapper.classList.remove('is-playing'); }
      });
    });
    videos.forEach((video) => video.addEventListener('ended', () => video.closest('.product-ugc__video')?.classList.remove('is-playing')));
    const move = (direction) => track?.scrollBy({ left: direction * Math.max(220, track.clientWidth * .34), behavior: 'smooth' });
    carousel.querySelector('[data-ugc-prev]')?.addEventListener('click', () => move(-1));
    carousel.querySelector('[data-ugc-next]')?.addEventListener('click', () => move(1));
  });
});
